import { ComponentStyleConfig } from "@chakra-ui/react";

const Container: ComponentStyleConfig = {
	baseStyle: {
		maxW: "container.xl",
	},
};

export default Container;
